/**
 * Lookup de coberturas (covering designs) ótimas pré-calculadas.
 *
 * Uma cobertura C(v, k, t) é um conjunto mínimo de blocos de tamanho k
 * (escolhidos de um universo de v elementos) tal que todo subconjunto de
 * tamanho t do universo está contido em pelo menos um bloco.
 *
 * No contexto de fechamento de loteria:
 *   v = número de dezenas escolhidas pelo apostador
 *   k = número de dezenas por jogo
 *   t = meta de acertos garantida se TODAS as v dezenas saírem
 *       (na prática: se ao menos t das v dezenas saírem, um dos jogos
 *       gerados contém pelo menos t acertos)
 *
 * Os dados vêm do La Jolla Covering Repository (ljcr.dmgordon.org),
 * dataset público clássico de combinatória.
 */

import { COVERINGS } from "./data";

/** Retorna os blocos (índices 0..v-1) ou null se o caso não estiver tabulado. */
export function lookupCovering(v: number, k: number, t: number): number[][] | null {
  if (t <= 0 || k <= 0 || v <= 0) return null;
  if (t > k || k > v) return null;
  const key = `${v}_${k}_${t}`;
  return COVERINGS[key] ?? null;
}

/**
 * Aplica uma cobertura (blocos com índices 0..v-1) sobre um vetor de
 * dezenas reais escolhidas pelo usuário. Devolve a lista de jogos.
 */
export function applyCovering(blocks: number[][], numbers: number[]): number[][] {
  const sorted = [...numbers].sort((a, b) => a - b);
  return blocks.map((block) =>
    block.map((i) => sorted[i]).sort((a, b) => a - b),
  );
}